export default __webpack_public_path__ + "static/media/Pot3.b2940082.svg";